export default "__VITE_ASSET__MM4dK$CG__"